export const S3Bucket = {
    storageClass: 'api/aws/lookups/1.0/aws-s3-bucket-storage-class',
    bucketName: 'api/ri/resource/name/aws/1.0/preview/generate-resource-name',
    encryptionOptions: 'api/aws/lookups/1.0/aws-s3-bucket-encryption-options',
    replicatedRegion: (region) => `api/static/lookups/v2/1.0/aws-paired-region?region=${region}`,
};
export default S3Bucket;
